/**
 * @module geo/types/extensions
 * @prefered
 */
/**
 * Canvas extension type definition
 */
export interface Extension {
  /**
   * Type of the canvas extension
   */
  type: ExtensionType
  /**
   * Properties for canvas extensions
   * depends of extensionTypes
   */
  properties: ExtensionProperties
}

/**
 * Extension available types
 */
export enum ExtensionType {
  /**
   * type for search tooltip extension 
   */
  TOOLTIP = 'tooltip',
  /**
   * type for infosheet extension
   */
  INFOSHEET = 'infosheet',
  /**
   * type for search result extention
   */
  SEARCHRESULT = 'searchResult',
  /**
   * type for map toolbars extensions
   */
  MAP_TOOL = 'mapTool',
  /**
   * type for widget panel extension
   */
  WIDGET_PANEL = 'widgetPanel',
  /**
   * type for Bottom Panel extension
   */
  BOTTOM_PANEL = 'bottomPanel',
  /**
   * type for Function launcher extension
   * 
   */
  LAUNCHER = 'launcher',
  /**
   * type for thematics extension
   */
  THEMATICS = 'thematics',
  /**
   * type for thematics toolbar extension
   */
  THEMATICS_TOOLBAR = 'thematicsToolbar',
  /**
   * type for search result toolbar extension
   */
  SEARCH_TOOLBAR = 'searchToolbar',
  /**
   * type for analysis result toolbar extension
   */
  ANALYSES_TOOLBAR = 'analysesToolbar',
  /**
   * type for interactivity extension
   */
  INTERACTIVITY = 'interactivity',
  /**
   * type for Statistic result toolbar extension
   */
  STATS_TOOLBAR = 'statsToolbar',
  /**
   * type for global extension
   */
  GLOBAL = 'global'
}

/**
 * Default properties for canvas extension
 */
export interface ExtensionProperties {
  /**
   * Disable extension if in mobileapp
   */
  disableMobileapp?: boolean;
  /**
   * the key of extension
   */
  key?: string;
  /**
   * name of extension (if i18n use namekey)
   */
  name?: string;
  /**
   * a key to translate name of the extension
   */
  nameKey?: string;
  /**
   * higher priority extensions will trigger first
   * default is 0
   */
  priority?: number;
  /**
   * a string of one or more classes applied to the icon element
   */
  icon?: string;
  /**
   * a function that will be called on activation. Parmeters depend of extension
   * type
   */
  handle?: (...params: any[]) => void;
  /**
   * a function that will be called to know if extensions is enable. arguments
   * depends on extension type.
   */
  enable?: (...params: any[]) => boolean;
}
